import { type FC } from 'react';

import { RowWithFade } from '@/microfrontends/listing/shared/components/RowWithFade';

import { Title } from '../Title';

import styles from './NarrowTitle.css';

interface INarrowTitleProps {
  children: string;
}

export const NarrowTitle: FC<INarrowTitleProps> = ({ children }) => {
  return (
    <RowWithFade fadeWidth={70}>
      <div className={styles['inline-title']} title={children}>
        <Title>{children}</Title>
      </div>
    </RowWithFade>
  );
};
